import React from 'react';
import dayjs from 'dayjs';
import { useCountDown } from 'ahooks';

interface props {
  duration: number;
  showH?: boolean;
  showS?: boolean;
}

const DateFormatMin: React.FC<props> = ({ duration, showH, showS }) => {
  let hours = Math.floor(duration / 3600);
  let minutes = Math.floor((duration % 3600) / 60);
  let seconds = duration % 60;

  const returnShowS = () => {
    if (showS) {
      return (
        <>
          <span className="col333 f18 fw600">{seconds}</span>
          <span className="f14 col808">秒</span>
        </>
      );
    }
  };
  const returnShowH = () => {
    if (showH || hours > 0) {
      return (
        <>
          <span className="col333 f18 fw600">{hours}</span>
          <span className="f14 col808">小时</span>
        </>
      );
    }
  };

  return (
    <div className="flex_0" style={{ alignItems: 'flex-end', lineHeight: 1, fontSize: 12, gap: 6 }}>
      {returnShowH()}
      <span className="col333 f18 fw600">{minutes}</span>
      <span className="f14 col808">分钟</span>
      {returnShowS()}
    </div>
  );
};

export default DateFormatMin;
